import { takeEvery, delay } from 'redux-saga';
import fedops from './FedOps';
import { actions } from './fedOpsConsts';

function* mainAppLoaded() {
  yield delay(1);
  fedops.appLoaded();
}

export default function* ordersSagas() {
  yield [takeEvery(actions.mainAppLoaded, mainAppLoaded)];
}
